import { computed, Ref, ref } from 'vue';

export default (
  severity: Ref<
    'primary' | 'secondary' | 'regular' | 'success' | 'info' | 'warning' | 'help' | 'danger' | 'contrast' | 'delete' | undefined
  > = ref('primary'),
  rounded: Ref<Boolean> = ref(true),
  roundedFull: Ref<Boolean> = ref(true),
  isFlat: Ref<Boolean> = ref(false)
) => {
  const isPrimary = computed(() => severity.value == 'primary');
  const isSecondary = computed(() => severity.value == 'secondary');
  const isRegular = computed(() => severity.value == 'regular');
  const isDanger = computed(() => severity.value == 'danger');
  const isDelete = computed(() => severity.value == 'delete');
  const isInfo = computed(() => severity.value == 'info');

  return computed(() => {
    return {
      label: {
        class: '!flex-none text-[14px] font-semibold',
      },
      icon: ({ props }: any) => ({
        class: [
          {
            '!mr-1': props.iconPos == 'left' && props.label != null,
          },
        ],
      }),
      root: ({ props, context }: any) => ({
        class: [
          {
            '!px-[4px]': !!props.icon && !props.label?.length,
          },
          {
            '!px-2': !props.icon && !props.label?.length,
          },
          {
            'w-[40px] px-[4px] py-3': (props.label == null || props.label == '' || props.label == undefined) && props.icon !== null,
          },
          'focus:!ring-0 dark:focus:!ring-0',
          '!py-[10px]',
          {
            '!rounded-[8px]': rounded.value && !roundedFull.value,
            '!rounded-none': !rounded.value && !roundedFull.value,
            'rounded-full': roundedFull.value,
          },
          {
            '!text-white dark:!text-app-btn-text-dark': isPrimary.value,
            '!text-blue-700 dark:!text-blue-400': isSecondary.value,
            '!text-gray-700 dark:!text-app-btn-text-dark': isRegular.value,
            '!text-blue-700 dark:!text-blue-600': isInfo.value,
          },
          {
            'bg-blue-600 hover:!bg-[#175CD3]': isPrimary.value,
            '!bg-blue-50 hover:!bg-blue-100 dark:!bg-app-btn-dark hover:dark:!bg-gray-800': isSecondary.value && !isFlat.value,
            '!bg-transparent hover:!bg-blue-100 hover:dark:!bg-gray-800': isSecondary.value && isFlat.value,
            'bg-white hover:bg-gray-100 dark:!bg-app-btn-dark hover:dark:!bg-gray-800': isRegular.value,
            '!bg-red-200/20 hover:!bg-red-200/60 dark:bg-red-400/30 dark:hover:bg-red-400/40': isDanger.value,
            '!bg-red-600 text-white hover:!bg-red-200/60 dark:bg-red-400/30 dark:hover:bg-red-400/40': isDelete.value,
          },
          {
            '!border-blue-200': isPrimary.value || (isSecondary.value && !isFlat.value),
            '!border-0': isSecondary.value && isFlat.value,
            '!border-gray-300 dark:!border-gray-600': isRegular,
            'border-[#FECDCA]': isDanger.value,
            '!border-red-600': isDelete.value,
          },
        ],
      }),
    };
  });
};
